<template>
    <div class="header_container">
        <!-- <div class="world-left"></div>
        <div class="world-right"></div> -->
        <div class="headerWidth">
            <div class="headerLeft">
                <!-- <template v-if="!['xiaocao', 'gtgame'].includes(projectImgUrl)">
                    <div>{{ $t('简体中文') }}</div>
                    <span class="times">{{ $t('北京时间') }}：</span>
                    <span class="header-time-text">{{date}}</span>
                    <span>{{time}}</span>
                </template> -->
                <!-- <el-select v-model="selLang" :placeholder="$t('请选择')" size="small" class="lang-s" popper-class="lang-p" @change="handleSelectLang">
                    <template slot="prefix">
                        <img loading="lazy" v-lazy="require('../../../../assets/image/lang/lang.png')" width="20px" alt />
                    </template>
                    <el-option
                        v-for="(item, i) in langOpts"
                        :key="i"
                        :value="item.languageCode"
                    >
                        <img loading="lazy" v-lazy="$common.getImgUrl(item.countryFlag)" width="20px" style="margin-right: 12px" />
                        <span style="display: inline-block; width: 90px;">{{ item.languageName }}</span>
                        <span>{{ item.languageAbbr }}</span>
                    </el-option>
                </el-select> -->
                <ul>
                    <li @click="toHome">{{ $t('网站首页') }}</li>
                    <li class="liCenter" @click="toService">{{ $t('在线客服') }}</li>
                    <li class="liCenter" @click="$router.push({ path: '/agent' })">{{ $t('代理加盟') }}</li>
                    <li  class="liCenter" @click="toProxy">{{ $t('代理登陆') }}</li>
                    <!-- <template v-if="codeshow">
                        <li v-for="(item, index) in headerList" :key="index" @click="jump(item)" class="liCenter">
                                <i
                                    v-show="item.hotStatus"
                                    :style="
                                        'background-image:url(' +
                                        $common.getImgUrl(item.hotPic) +
                                        ')'
                                    "
                                ></i>
                                <span
                                    :style="{
                                        color: `${
                                            flashing && item.shineStatus
                                                ? item.shineColor
                                                : item.bottomColor
                                        }`,
                                    }"
                                >{{ item.name }}</span>
                        </li>
                    </template> -->
                </ul>
            </div>
            <div class="headerRight" v-show="!isLogin">
                <!-- <input type="text" :placeholder="$t('账号')" v-model="account" @blur="accountBlur" />
                <div class="password">
                    <input type="password" :placeholder="$t('密码')" v-model="pwd" @blur="passwordBlur" />
                    <span @click="to('pwdforget')">{{ $t('忘记') }}？</span>
                </div>
                <div v-show="showPicture" class="defaultPicture">{{ $t('获取中') }}</div> -->
                <div
                    v-show="!showPicture"
                    style="width: 2.6rem;display: flex;justify-content: center;align-items: center;"
                >
                    <!-- <template v-if="type == 0">
                        <div class="loginBorder">
                            <input
                                class="loginInput"
                                style="padding-left: 5px;"
                                :placeholder="$t('验证码')"
                                v-model="code"
                            />
                        </div>
                        <div
                            :style="'background-image:url('+verifyCodeImg+')'"
                            class="codeimg"
                            v-if="verifyCodeImg"
                            @click="captchaData"
                        ></div>
                        <div
                            class="verifyCodeImg getCode"
                            v-if="!verifyCodeImg"
                            @click="captchaData"
                        >
                            <img loading="lazy" v-lazy="require('../../../../assets/image/refresh.png')" class="refimg" alt />{{ $t('重新获取') }}
                        </div>
                    </template> -->

                    <!-- 行为校验  树莓 -->
                    <!-- <div
                        v-show="type === 2"
                        id="captcha"
                        class="captchaStyle"
                        @click="captchaClick"
                    >{{ captchaText }}</div> -->

                    <!--  行为验证 极验 -->
                    <!-- <div class="logRow" v-if="type === 1">
                        <div v-show="type === 1" id="captcha1" class></div>
                        <div v-if="errorCode" class="getCode" @click="getDefaultStatus">
                            <img loading="lazy" v-lazy="require('../../../../assets/image/refresh.png')" class="refimg" alt />{{ $t('重新获取') }}
                        </div>
                    </div> -->
                    <!-- 极验4 -->
                    <!-- <div v-if="type === 3" id="gt4"></div> -->
                </div>
                <div class="leftButton">
                    <div class="leftButtonOne" @click="loginAction">
                        <span>{{ $t('登入') }}</span>
                        <span>{{ $t('登入') }}</span>
                    </div>
                </div>
                <!-- <div>点击登入表示同意<span>协议与规则</span></div> -->
                <div class="rightButton">
                    <!-- eslint-disable-next-line vue/custom-event-name-casing -->
                    <!-- <div class="rightButtonOne" @click="$emit('openRegister')"> -->
                    <div class="rightButtonOne" @click="loginAction('register')">
                        <span>{{ $t('注册') }}</span>
                        <span>{{ $t('注册') }}</span>
                    </div>
                </div>
            </div>
            <div class="loginSuccessfulRight" v-show="isLogin">
                <div class="user">
                    <span>{{ $t('账号') }}：</span>
                    <span class="name">{{userName}}</span>
                </div>
                <img loading="lazy"
                    class="vipImg"
                    @click="openVip()"
                    v-lazy="require('../../../../assets/image/xfImg/'+vipImg+'.png')"
                    alt
                />
                <div class="balance">
                    <span>{{ $t('余额') }}：</span>
                    <span
                        class="amount"
                    >{{ $common.setNumFixed($store.state.userInfo.totalBalance,2) }}</span>
                    <i
                        :class="{ refreshAnimation: haveRefreshAnimation }"
                        @click="getUserBalance('refresh')"
                    ></i>
                </div>
                <ul class="other">
                    <li @click="to('myAccount')">{{ $t('会员中心') }}</li>
                    <li @click="to('recharge')">{{ $t('线上存款') }}</li>
                    <li @click="to('drawing')">{{ $t('线上取款') }}</li>
                    <li @click="onGetMoney">{{ $t('一键归户') }}</li>
                    <li @click="to('news')">{{ $t('未读讯息') }}(<span style="color:red;">{{msgUnReadNum + noticeUnReadNum }}</span>)</li>
                    <li class="logout" @click="logout()">{{ $t('登出') }}</li>
                </ul>
            </div>
        </div>
        <!-- eslint-disable-next-line vue/custom-event-name-casing -->
        <menu-list class="menulist" @setregister="$emit('openRegister')" @scrollToCode="$emit('scrollToCode')"></menu-list>
        <verifyIdentidy ref="verifyIdentidy" @loginAction="loginAction" :account="account"></verifyIdentidy>
    </div>
</template>
<script>
import { mapMutations } from 'vuex'
import menuList from "./menuList";
import verifyIdentidy from '@/components/verifyIdentidy/verifyIdentidy';
import MyAes from "@/utils/myAes.js";
import utils from '@/utils/utils.js'
import { changeLang, langObj } from '@/i18n'
import { _getDeviceId }  from '@/utils/finger.js';
import store from "@/store/store";
import "@/utils/smcp.min.js";
import "@/utils/boc.js"
import { mapGetters } from "vuex";
export default {
    components: {
        menuList,
        verifyIdentidy
    },
    data() {
        return {
            isLogin: false,
            userName: "",
            pwd: "",
            // time: "--年--日--月 --:--:--",
            zone: 'UTC+8',
            date: '',
            time: '',
            interval: 0,
            captchaKey: "",
            setInt: null,
            isClickLogin: true, //只有第一次登录生效，除非登录失败
            code: "",
            balance: "0.00",
            account: "",
            verifyCodeImg: "",
            type: 0, //行为校验2
            captcha: null, //行为校验
            captchaBox: null,
            captchaText: "",
            captchaMask: false,
            headerList:[],
            flashing: false,
            errorCode: false,
            showPicture: true,
            haveRefreshAnimation: false, //开始刷新动画
            refreshBalanceFlag: true, //不可重复刷新余额
            msgUnReadNum: 0,
            noticeUnReadNum: 0,
            selLang: '',
            vipList: [],
            vipImg: "normal_user",
            userName: "",
            proxyUrl: "",
            codeshow:true,
            // 数美请求参数
            smData:{
                lang: '',
                mode: '',
                organization: '',
                product: '',
                appId: '',
                channel: '',
            },
            langOpts: [
                { languageName: 'Trang chủ', languageAbbr: 'TC', languageCode: 'vi', icon: 'tc' },
                { languageName: 'English', languageAbbr: 'EN', languageCode: 'en', icon: 'en' },
                { languageName: '中文-简体', languageAbbr: '简', languageCode: 'zh_CN', icon: 'zh_cn' },
                // { languageName: '中文-繁体', languageAbbr: '繁', value: 'zh_TW', icon: 'zh_hk' },
            ],
            fingerprintState:false,
            projectImgUrl: window.projectImgUrl
        };
    },
    created() {
        this.getServer()
        if (this.$common.isLogin()) {
            this.isLogin = true;
            this.setupLoginInfo();
            //未读条数
            this.getMessages();
            this.getNotices();
            this.logins(this.isLogin);
        }
        this.listQuickEntry();
        this.codeShow();
        this.getLang()
    },
    computed: {
        ...mapGetters(["userInfo"]),
        needCheckLogin() {
            return this.$store.state.needCheckLogin;
        }
    },
    mounted() {
        this.getDefaultStatus();
        // this.getTime()
        this.getLangOpts()
        // setInterval(() => {
        //     var date = new Date(); //获得当前时间
        //     var yy = date.getFullYear(); //年份
        //     var mm = date.getMonth() + 1; //获得月份
        //     mm = mm < 10 ? "0" + mm : mm; //月份小于10时，前面加个0(例如9 ->09)天，小时，分钟，秒同理
        //     var dd =
        //         date.getDate() < 10 ? "0" + date.getDate() : date.getDate(); //天
        //     var hours =
        //         date.getHours() < 10 ? "0" + date.getHours() : date.getHours(); //小时
        //     var minutes =
        //         date.getMinutes() < 10
        //             ? "0" + date.getMinutes()
        //             : date.getMinutes(); //分钟
        //     var seconds =
        //         date.getSeconds() < 10
        //             ? "0" + date.getSeconds()
        //             : date.getSeconds(); //秒
        //     this.time =
        //         yy +
        //         "年" +
        //         mm +
        //         "月" +
        //         dd +
        //         "日 " +
        //         hours +
        //         ":" +
        //         minutes +
        //         ":" +
        //         seconds;
        // }, 1000);
    },
    methods: {
        ...mapMutations(['setShowLogin']),
        async getLangOpts() {
            const res = await this.$http.get(this.$api.getLangList)
            if (res.code === 0) {
                this.langOpts = res.data
                this.getLang()
            }
        },
        // 获取语言
        getLang(l) {
            const local = this.$i18n.locale
            const { languageName } = this.langOpts.find(o => l ? l === o.languageCode : langObj[o.languageCode] === local) || {}
            if (languageName) {
                this.selLang = languageName
            }
        },
        // 换语言
        handleSelectLang(v) {
            this.getLang(v)
            const { languageCode } = this.langOpts.find(o => o.languageCode === v) || {}
            languageCode && changeLang(languageCode)
        },
        // 客服问题
        async getServer(){
            const res = await this.$http.get(this.$api.allHour);
            if(res.code===0){
                this.$cache.set('wnsrServerUrl',res.data.domain)
            }
            console.log(res.maintainUrl,"ddddd",res)
        },
        getTime () {
            this.interval = setInterval(() => {
                var bjTime = this.getBjTime();
                this.date = utils._formatDate(bjTime, 'yyyy-MM-dd')
                this.time = utils._formatDate(bjTime, 'HH:mm:ss')
            }, 500)
        },
        getBjTime() {
            //获得当前运行环境时间
            var d = new Date(), currentDate = new Date(), tmpHours = currentDate.getHours();
            //算得时区
            var time_zone = -d.getTimezoneOffset() / 60;
            //少于0的是西区 西区应该用时区绝对值加京八区 重新设置时间（西区时间比东区时间早 所以加时区间隔）
            if (time_zone < 0) {
                time_zone = Math.abs(time_zone) + 8; currentDate.setHours(tmpHours + time_zone);
            } else {
                //大于0的是东区  东区时间直接跟京八区相减
                time_zone -= 8; currentDate.setHours(tmpHours - time_zone);
            }
            return currentDate;
        },
        codeShow(){
            if(window.projectImgUrl == 'jryl'){
                this.codeshow = false;
            }
            else{

            }
        },
        listQuickEntry: async function() {
            const res = await this.$http.get(this.$api.listQuickEntry, false);
            if (res.code === 0 && res.data.length != 0) {
                res.data.sort((item1, item2) => {
                    return item1.sort - item2.sort;
                });
                this.headerList = res.data;
                setInterval(() => {
                    this.flashing = true;
                }, 200);
                setInterval(() => {
                    this.flashing = false;
                }, 400);
            }
        },
        openVip() {
            if (!['jryl','tyca','jramjs','jrwnsr'].includes(window.projectImgUrl)) {
                this.$router.push({ path: '/vipLevel' });
            } else {
                this.$emit("openVip");
            }
        },
        async logins(isLogin) {
            let that = this;
            if (isLogin) {
                that.userName = that.$common.getUser().username;
                let data = "/" + that.$common.getUser().user_id;
                const res = await that.$http.get(that.$api.members, data);
                if (res.code == 0) {
                    that.getVipData(res.data.levelId);
                }
            }
        },
        async getVipData(levelId) {
            let that = this;
            let res = await that.$http.get(that.$api.getvipdata, levelId);
            if (res.code == 0) {
                if (res.data.gradeId === 1) {
                    that.vipImg = "normal_user";
                } else {
                    that.vipImg = res.data.gradeName;
                }
            }
        },
        toHome() {
            this.$router.push({ path: "/home" });
        },
        toProxy() {
            const proxyUrl =  this.$common.getClientCodeRes()?.agentDomain;
            
            // switch (window.projectImgUrl) {
            //     case 'tyca':
            //         this.proxyUrl = 'https://jragent.715536.com'
            //     case 'jryl':
            //         this.proxyUrl = 'https://jragent.715536.com'
            //         break
            //     case 'qxyl':
            //         this.proxyUrl = 'https://qxylagent.bets888803.com'
            //         break
            //     case 'amxpj':
            //         this.proxyUrl = 'https://agent.tp9km5qt.vip'
            //         break
            //     case 'amwnsr':
            //         this.proxyUrl = 'https://agent.715639.com'
            //         break
            //     case 'funw':
            //         this.proxyUrl = 'https://agent.6hqpxiwqfg.com'// funw 泛游
            //         break
            //     case 'bqty':
            //         this.proxyUrl = 'https://agent.6hqpxiwqfg.com'// bqty
            //         break
       
            // }
            let win = window.open()
            setTimeout(()=>{
                 win.location.href = proxyUrl
            },100)
            // window.open(proxyUrl, "_blank");
        },
        toService() {
            this.$common.toService()
            // 越南台子统一用在线客服

            //新旧客服判断
            // if (window.customerServiceStatus == 1) {
            //     //新客服
            //     var obj = {};
            //     obj.host = this.$common.getHost();
            //     obj.clientCode = window.clientCode;
            //     obj.clientItem = window.childCode;
            //     obj.username =
            //         this.$common.getUser() && this.$common.getUser().username;
            //     obj.language = "zh_CN";
            //     obj.theme = window.theme;
            //     obj.projectImgUrl = window.projectImgUrl;
            //     obj.orgin = window.location.origin + "/activity";
            //     var str = JSON.stringify(obj);
            //     str = window.btoa(str);
            //     let url = location.origin  + "/func" + "/customerService/pc?s=" + str;
            //     window.open(url, "_blank");
            // } else {
            //     //旧客服
            //     const url = this.$common.getCustomerService();
            //     window.open(url, "_blank");
            // }
        },
        to(name) {
            //新窗口跳转
            // this.$router.push({
            //     name: name
            // })
            //  澳门威尼斯人统计
            if(window.projectImgUrl == 'funw' && name== 'recharge'){
				_paq.push([
				  "trackEvent",
				  "PC_btn",
				  "PC_btn",
				  this.$t('PC首页充值按钮')
				]);
				_paq.push(["trackGoal", 1]);
            }
            const { href } = this.$router.resolve({
                name: name
            });
            window.open(href, "_self");
        },
        loginAction(type) {
            this.setShowLogin({ show: true, isLogin: type !== 'register' })
            return
            var _this = this;
            var aseKey = "pigxpigxpigxpigx"; //秘钥
            // Encrypt 加密·
            let encryptionPassword = MyAes.encrypt(this.pwd, aseKey);
            let param = {
                name: this.account,
                password: encryptionPassword,
                fingerprint: this.$config.fingerprint
            };

            //账号处理
            if (window.mergeAccount) {
                param.name = this.account + window.mergeAccount;
            }
            this.$http.post(this.$api.validateLogin, param).then(res => {
                // res.data.validateWay = "device"
                // res.data.validateStatus = false;
                if (res.code == 0) {
                    this.validateStatus = res.data.validateStatus ? 1 : 0;
                    if (this.validateStatus === 1) {
                        //无异常
                        this.Login();
                    } else {
                        if(res.data.validateWay == "ip") {
                            // 验证真实姓名
                            this.$emit("showPopup", true);
                        } 
                        if(res.data.validateWay == "device") {
                            // 验证设备
                            this.$refs.verifyIdentidy.openDialog();
                        }
                    }
                } else {
                    this.$message.error(res.msg);
                    if (this.type === 1) {
                        captcha1.innerHTML = "";
                    }
                    this.getDefaultStatus();
                }
            });
        },
        validateRealName(name) {
            let param = {
                name: this.account,
                realName: name
            };

            //账号处理
            if (window.mergeAccount) {
                param.name = this.account + window.mergeAccount;
            }
            this.$http.post(this.$api.validateRealName, param).then(res => {
                if (res.code == 1) {
                    this.$message.error(res.msg);
                } else if (res.data.validateStatus) {
                    this.Login();
                    // eslint-disable-next-line vue/custom-event-name-casing
                    this.$emit("showPopup", false);
                } else {
                    this.$message.error(
                        this.$t(`您的输入有误，还有{x}次验证机会，超过次数会冻结账号哦！`, { x: res.data.surplusCount })
                    );
                }
            });
        },
        // 获取   getDefaultStatus
        getDefaultStatus() {
            let _this = this;
            this.$http.get(this.$api.getDefaultStatus, false).then(res => {
                if (res.code == 0) {
                    // type   0：默认验证码  1：极验  2：数美"
                    _this.type = res.data.type;
                    // _this.type = 1;
                    if (_this.type === 0) {
                        //图片验证码
                        //获取验证码图片
                        this.captchaData();
                    } else if (_this.type === 1 || _this.type === 3) {
                        //1：极验
                        _this.disabled = false;
                        this.showPicture = false;
                        _this.reset();
                    } else if (_this.type === 2) {
                        //2：数美"
                        this.showPicture = false;
                        Object.assign(_this.smData,res.data)
                        _this.reset();
                        
                    }
                    this.fingerprintState = res.data.fingerprintState
                    if(this.fingerprintState){
                        _getDeviceId(res.data.fingerprintId).then( res => {
                            this.$config.fingerprint = res
                            sessionStorage.setItem('fingerprint', res);
                        })
                    }
                } else {
                    this.errorCode = true;
                    this.type = null;
                    this.moneyModeListReqSuccess = false;
                    this.$message.error(this.$t('加载失败，请重试'));
                }
            });
        },
        //行为校验↓
        reset() {
            this.check();
            this.getCaptcha();
        },
        check() {
            if(this.type ===1){
                if (this.captcha) {
                    this.captchaText = "";
                } else {
                    this.captchaText = this.$t('正在加载') + "...";
                }
            } else {
                this.captcha && this.captcha.reset()
            }
        },
        getCaptcha() {
            if (this.type == 1) {
                let _this = this;
                this.$http
                    .get(
                        this.$api.geetFirstRegister,
                        "?t=" + window.childCode,
                        false
                    )
                    .then(res => {
                        if (res.code == 0) {
                            window.initGeetest(
                                {
                                    gt: res.data.gt,
                                    challenge: res.data.challenge,
                                    new_captcha: res.data.newCaptcha, // 用于宕机时表示是新验证码的宕机
                                    offline: res.data.success !== 1, // 表示用户后台检测极验服务器是否宕机，一般不需要关注
                                    product: "float", // 产品形式，包括：float，popup
                                    width: "100%",
                                    lang: "cn"
                                },
                                _this.onCaptcha
                            );
                        } else {
                            this.$message.error(this.$t('获取错误'));
                        }
                    });
            } else if (this.type == 2) {
                let data ={
                    ...this.smData,
                        width:300,
                    https:location.protocol == "https:"
				}
                initSMCaptcha(
				    data,
                    this.onCaptcha
                );
            } else if(this.type ===3) {
                if(!this.captcha){
                    initBotion({
                        captchaId: this.$config.captchaId,
                        product: 'popup',//float  popup
                        language: 'vie',
                        nativeButton:{
                            width: '1.8rem',
                            height: '0.3rem'
                        }
                    }, this.onCaptcha);
                }
            }
        },
        onCaptcha(res) {
            //res是验证实例，可以调用res的示例方法
            var _this = this;
            this.captcha = res;
            console.log(res,"res");
            if (_this.type == 1) {
                res.appendTo("#captcha1");
                res.onReady(_this.check);
            } else if (this.type == 2) {
                this.captchaText = this.$t("点击验证");
                this.captcha.onSuccess(function(data) {
                    if (data.pass) {
                        _this.disabled = false;
                        _this.captcha.rid = data.rid;
                        _this.captchaText = this.$t("验证成功");
                        _this.captchaMask = false;
                    } else {
                        _this.captcha.rid = null;
                        _this.captchaText = this.$t("验证失败");
                    }
                });

                this.captcha.onError(function() {
                    _this.captcha.rid = null;
                    _this.captchaText = this.$t("验证失败");
                    _this.captchaMask = false;
                });

                this.captcha.onClose(function() {
                    _this.captchaMask = false;
                });
            } else if(this.type === 3){
                res.appendTo("#gt4")
            }
        },
        captchaClick() {
            if (this.type == 2) {
                var result = this.captcha.getResult();
                var pass = result.pass;
                if (!pass) {
                    this.captcha.verify();
                    //行为验证bug:点击关闭按钮，会点击穿透
                    //解决：手动再添加一个遮罩层
                    this.captchaMask = true;
                }
            }
        },
        captchaData: async function() {
            let _this = this;
            const res = await this.$http.get(_this.$api.captcha);
            if (res.code == 0) {
                _this.verifyCodeImg = res.data.captcha_image_content;
                // _this.captchaCode = res.data.captchaCode;
                _this.captchaKey = res.data.captchaKey;
                _this.showPicture = false;
            } else {
                // this.$message.error(res.msg + "");
            }
        },
        accountBlur() {
            //大写转小写
            this.account = this.account.toLowerCase();
            //空格处理
            this.account = this.account.replace(/\ /g, "");
        },
        passwordBlur() {
            //空格处理
            // this.pwd = this.pwd.replace(/\ /g, "");
        },
        Login: async function() {
            let _this = this;

            if (!this.account) {
                // this.$message.error("请输入账号");
                const msg = this.$message.error(this.$t("请输入账号"));
                   setTimeout(() => {
                        msg.close();
                    }, 2000); 
                return;
            }
            if (!this.pwd) {
                // this.$message.error("请输入密码");
                const msg = this.$message.error(this.$t("请输入密码"));
                   setTimeout(() => {
                        msg.close();
                    }, 2000); 
                return;
            }

            if (!this.code && this.type == 0) {
                // this.$message.error("请输入验证码");
                const msg = this.$message.error(this.$t("请输入验证码"));
                   setTimeout(() => {
                        msg.close();
                    }, 2000); 
                    return;
            }

            if (this.type != 0) {
                var result = this.captcha.getValidate();
                if (!result) {
                       // this.$message.error("请先通过行为验证");
                   const msg = this.$message.error(this.$t("请先通过行为验证"));
                   setTimeout(() => {
                        msg.close();
                    }, 2000); 
                    return;
                }
            }

            //登录接口
            var aseKey = "pigxpigxpigxpigx"; //秘钥
            // Encrypt 加密
            let encodePassword = MyAes.encrypt(this.pwd, aseKey);
            // Decrypt 解密
            let decodePassword = MyAes.decrypt(encodePassword, aseKey);

            //   if (!this.isClickLogin) {
            //     return;
            //   }

            this.isClickLogin = false;

            let params = {
                name: this.account,
                password: encodePassword,
                lastLoginVersion: this.$config.loginVersion,
                validateType: this.type,
            };

            //账号处理
            if (window.mergeAccount) {
                params.name = this.account + window.mergeAccount;
            }
            if (this.type === 1) {
                params.geeTestQueryVO = {
                    challenge: result.geetest_challenge,
                    seccode: result.geetest_seccode,
                    validate: result.geetest_validate
                };
            } else if (this.type === 2) {
                params.shuMeiQueryVO = {
                    rid: result.rid
                };
            } else if (this.type === 0) {
                params.captchaKey = this.captchaKey;
                params.captchaCode = this.code;
            } else if (this.type === 3){
                params.geeTestQueryVO = result
            }   

            if(this.fingerprintState){
                params.fingerprint =  this.$config.fingerprint;
                params.phoneModel =  this.$config.phoneModel;
            }
            const res = await _this.$http.post(_this.$api.login, params);
            if (res.code == 0) {
                _this.$common.setToken(res.data);
                _this.$common.setUser(res.data);
                //登陆成功提示
                this.$message({
                    message: this.$t("恭喜您，登录成功"),
                    type: "success"
                });

                this.$router.push("/");
                //第一次登陆
                sessionStorage.setItem("firstLogin", true);

                store.commit("firstLogin", true);
                this.$common.showLogin();
                //获取余额
                // this.getUserBalance();
                //获取用户信息
                this.$nkhttp.getUserInfo();
                //
                // this.$emit("ensureLogin", "");
                this.code = "";
                this.getMessages();
                this.getNotices();
                this.$store.commit('setQxylChat',1)
            } else {
                this.isClickLogin = true;
                this.validateStatus === -1
                this.$common.clearToken();
                this.$message.error(res.msg);
                if (_this.type === 1) {
                    captcha1.innerHTML = "";
                }
                this.getDefaultStatus();
            }
        },
        async getUserBalance(type) {
            var _this = this;
            //只针对手动点击刷新（10s内不可以重复刷新）
            if (!type) {
                _this.haveRefreshAnimation = true;

                let data = {
                    clientId: this.$common.getUser().tenant_id, //tenant_id
                    clientIp: this.$config.clientIp,
                    memberId: this.$common.getUser().user_id, //userid
                    username: this.$common.getUser().username
                };
                var res = await _this.$http.post(_this.$api.getuserMoney, data);
                if (res.code == 0) {
                    this.balance =
                        typeof res.data.totalBalance != "undefined"
                            ? res.data.totalBalance
                            : "0.00";
                    //结束刷新动画
                    _this.haveRefreshAnimation = false;
                    //余额存本地
                    this.$store.commit("updataUserInfo", res.data);

                    this.$common.setUserBalance(res.data);
                    this.$common.showLogin();
                } else {
                    //结束刷新动画
                    _this.haveRefreshAnimation = false;
                    //连续刷新不能报错
                    if (res.code != 10041) {
                        this.$message.error(res.msg);
                    }
                }
            } else {
                //手动刷新余额
                if (_this.refreshBalanceFlag) {
                    _this.haveRefreshAnimation = true;
                    _this.refreshBalanceFlag = false;

                    let data = {
                        clientId: this.$common.getUser().tenant_id, //tenant_id
                        clientIp: this.$config.clientIp,
                        memberId: this.$common.getUser().user_id, //userid
                        username: this.$common.getUser().username
                    };
                    var res = await _this.$http.post(
                        _this.$api.getuserMoney,
                        data,
                        true
                    );
                    if (res.code == 0) {
                        this.balance =
                            typeof res.data.totalBalance != "undefined"
                                ? res.data.totalBalance
                                : "0.00";
                        //结束刷新动画
                        _this.haveRefreshAnimation = false;
                        //余额存本地
                        this.$store.commit("updataUserInfo", res.data);
                        this.$common.setUserBalance(res.data);
                        this.$common.showLogin();

                        //提示用户,余额请求成功
                        this.$message.success(this.$t("刷新余额成功"));
                    } else {
                        this.$message.error(res.msg);
                        //结束刷新动画
                        _this.haveRefreshAnimation = true;
                    }

                    setTimeout(() => {
                        //10s后，才可以再次刷新
                        _this.refreshBalanceFlag = true;
                    }, 10000);
                } else {
                    //不可重复请求
                    this.$http.showMesasge(this.$t("点击间隔10s，请勿重复操作!"));
                }
            }
        },
        logout() {
            sessionStorage.setItem("firstLogin", false);
            this.$store.commit("firstLogin", false);
            this.$http.delete(this.$api.logout).then(res => {
                if (res.data === true) {
                    this.$common.clearToken();
                    this.$store.commit("setToken", null);
                    this.balance = "0.00";
                    //数据初始化
                    this.account = "";
                    this.pwd = "";
                    this.$router.push({ path: "/home" });
                }
            });
        },
        setupLoginInfo() {
            if (this.$common.getUser()) {
                this.userName = this.$common.getUser().username;
            }
            // this.getUserBalance();
        },
        async getMessages() {
            var _this = this;
            var data = {
                currentPage: "",
                pageSize: "",
                receiverType: 0
            };
            var res = await _this.$http.post(_this.$api.message, data);
            if (res.code == 0) {
                let messages = res.data.content;
                _this.msgUnReadNum = res.data.unreadCount;
            } else {
                this.$message.error(res.msg);
            }
        },
        async getNotices() {
            var _this = this;
            var data = {
                createdAt: "",
                currentPage: "",
                pageSize: "",
                publishedAt: "",
                subject: "",
                type: ""
            };
            var res = await _this.$http.post(_this.$api.noticeList, data);
            if (res.code == 0) {
                let noticesData = res.data.content;
                _this.noticeUnReadNum = res.data.unreadCount;
            } else {
                this.$message.error(res.msg);
            }
        },
        //一键归户
        onGetMoney() {
            let option = {
                clientId: this.$common.getUser().tenant_id, //tenant_id
                clientIp: this.$config.clientIp,
                memberId: this.$common.getUser().user_id, //userid
                username: this.$common.getUser().username
            };
            this.$http.post(this.$api.oneKeyBalance, option, true).then(res => {
                if (res.code == 0) {
                    this.$message.success(this.$t("归集成功"));
                    this.getUserBalance();
                }
            });
        },
        // 头部动态跳转
        jump(item) {
            if (item.editStatus === 0) {
                switch (item.fixedCode) {
                    case this.$t("充值中心"):
                        if (this.$common.getUser()) {
                            this.$router.push("/rechange");
                        } else {
                            // this.$message.error('您还未登录请前往登录');
                            this.$common.openLogin()
                        }
                        break;
                    case this.$t("合作伙伴"):
                        this.$router.push("/cooperation");
                        break;
                    case this.$t('APP下载'):
                        this.$router.push("/app");
                        break;
                }
            } else {
                // if (this.$common.getUser()) {
                    switch (item.jumpType) {
                        case 0: //路径
                            if (item.openType === 0) {
                                window.open(item.jumpContent, "_self");
                            } else {
                                window.open(item.jumpContent, "_blank");
                            }
                            break;
                        case 1: //公告(打开的是公告详情)
                            // eslint-disable-next-line no-case-declarations
                            this.openNotice()
                            // this.$router.push("/noticeInfo?type=2");
                            // let items = {
                            //     id: item.jumpContent
                            // };
                            // this.$store.commit("showSwiperNoticeDetail", items);
                            // break;
                        case 2: //活动(打开的是优惠活动详情)id
                            // eslint-disable-next-line no-case-declarations
                            this.$router.push(
                                "/actDetail?id=" + item.jumpContent
                            );
                            break;
                        case 3: //专题活动(打开的是限时优惠详情)
                            this.$http.get(this.$api.getThematicActivitiesByApp + '/' + item.jumpContent,'',true).then((res) => {
                                if (res.code == 0 && res.data) {
                                    if (res.data.type == 2) {
                                        if (this.$common.getUser()) {
                                            this.$router.push({
                                                path: "/signInPage",
                                                query: {
                                                    id: res.data.id
                                                }
                                            });
                                        } else {
                                            // this.$message.error(this.$t('您还未登录请前往登录'));
                                            this.$common.openLogin()
                                            this.$store.commit("loginNavId", 0);
                                            showLogin({
                                                show: true
                                            });
                                        }
                                    } else {
                                        this.$router.push({
                                        // 从专题活动进入
                                            path: "/actDetail",
                                            query: {
                                                byAppId: item.jumpContent
                                            }
                                        });
                                    }
                                }
                            });
                            break;
                        case 4: //游戏
                                // 进入游戏
                                if (this.$common.getUser()) {
                                    let that = this;

                                    that.tenantId = that.$common.getUser().tenant_id;
                                    that.username = that.$common.getUser().username;
                                    that.uid = that.$common.getUser().user_id;
                                    let data = {
                                        tenantId: that.tenantId,
                                        username: that.username,
                                        gameId: item.jumpContent,
                                        clientIp: that.$config.clientIp,
                                        memberId: that.uid,
                                        terminalType: 1
                                    };
                                    that.$common.setGameRequestData(data);
                                    that.$http.post(that.$api.getToken, data, true).then((res) => {
                                        if (res.code == 0) {
                                            that.gameUrl = res.data;
                                            window.open(that.gameUrl);
                                        } else {
                                            if (item.openType === 1) {
                                                window.open("/error.html?type=1");
                                            }
                                            let msg = that.$t(`errorCode.${res.code}`) + `(${res.code})` || this.$t('网络响应异常，请稍后再试，或联系客服咨询');
                                            that.$http.errMsg(msg);
                                        }
                                    })
                                } else {
                                    // this.$message.error(this.$t('您还未登录请前往登录'));
                                    this.$common.openLogin()
                                    this.$store.commit("loginNavId", 0);
                                    showLogin({
                                        show: true
                                    });
                                }
                            break;

                        case 7:
                            if(item.url){
                                this.$router.push({path: item.url})
                            }
                    }
                // } else {
                //     this.$message.error(this.$t('vip.gotologin'));
                //     this.$store.commit("loginNavId", 0);
                //     showLogin({
                //         show: true
                //     });
                // }
            }
        },
    },
    watch: {
        isLogin(n) {
            if (n) {
                this.setupLoginInfo();
            } else {
                //账号在其他地方登陆（被踢）
                //数据重置
                if (this.type == 1) {
                    captcha1.innerHTML = "";
                }
                this.getDefaultStatus();
            }
        },
        "$store.state.token"(n) {
            //监听token，判断是否登录
            this.isLogin = !!n;
            this.logins(n);
        }
    },
    beforeDestroy () {
        if (this.interval) clearInterval(this.interval)
    }
};
</script>

<style lang='less' scoped>
.vipImg {
    width: 0.55rem;
    height: 0.22rem;
    margin: auto 0.05rem;
}
.menulist {
    width: 14rem;
    height: 0.76rem;
    margin: 0 auto;
    margin-top: 0.07rem;
}
.header-time-text{
    margin: 0 0.05rem;
}
.header_container {
    width: 19.2rem;
    height: 0.5rem;
    position: fixed;
    left: 0;
    top: 0;
    background-color: #000;
    z-index: 999;
    text-align: center;
    line-height: 0.5rem;
    color: #fff;
}
.headerWidth {
    width: 85%;
    min-width: 10rem;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
}
.header_container .headerLeft {
    display: flex;
}
.world-left, .world-right {
    width: 3.69rem;
    height: 0.76rem;
    position: absolute;
    bottom: 0;
    background: url("../../../../assets/image/qqImg/cupLeft.png") no-repeat;
    background-size: 100% 100%;
}
.world-right {
    right: 0;
    background: url("../../../../assets/image/qqImg/cupRight.png") no-repeat;
}
.headerLeft span.times {
    color: rgba(239, 199, 122);
    margin-left: 0.1rem;
}
.headerLeft ul {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
}
.headerLeft ul li {
    margin: 0 0.1rem;
}
.headerLeft ul li:hover {
    color: rgba(239, 199, 122);
}
.headerLeft ul .liCenter {
    border-left: 0.01rem solid #fff;
    height: 0.1rem;
    line-height: 0.1rem;
    padding: 0 0.1rem;
    margin: 0;
    box-sizing: border-box;
}
.headerRight {
    display: flex;
    align-items: center;
    .captchaStyle {
        cursor: pointer;
        justify-content: center;
        align-items: center;
        display: flex;
        align-items: center;
        width: 80%;
        height: 0.34rem;
        padding: 0 0.09rem;
        border-radius: 0.1rem;
        line-height: 0.28rem;
        background-color: #000;
        border: 0.01rem solid #3c3c3c;
        color: #fff;
        box-shadow: 0px 0.03rem 0.06rem 0px #595959;
        &:hover {
            color: #000;
            background: linear-gradient(225deg, #9b7c4c 0%, #ffe7c1 100%);
        }
    }
}
.headerRight input {
    width: 1.28rem;
    height: 0.3rem;
    padding: 0 0.09rem;
    border-radius: 0.1rem;
    line-height: 0.28rem;
    background-color: #000;
    border: none;
    border: 0.01rem solid #3c3c3c;
    box-sizing: border-box;
    margin-right: 0.1rem;
    color: #fff;
}
.headerRight input:focus {
    border-color: #e2c285;
}
.headerRight .password {
    border-radius: 0.1rem;
    border: 0.01rem solid #3c3c3c;
    line-height: 0.28rem;
    margin-right: 0.1rem;
    position: relative;
    display: flex;
}
.password input {
    margin: 0;
    flex: 1;
    padding-right: 0.45rem;
    box-sizing: border-box;
}
.password span {
    position: absolute;
    top: 0;
    right: 0;
    color: rgba(239, 199, 122);
}
.password span:hover {
    color: red;
}
input::-webkit-input-placeholder {
    /* 修改字体颜色 */
    color: #fff;
    padding-left: 0.04rem;
}
.leftButton,
.rightButton {
    overflow: hidden;
    height: 0.34rem;
    margin-right: 0.1rem;
}
.leftButtonOne,
.rightButtonOne {
    display: flex;
    flex-direction: column;
    transition: transform 0.5s ease;
}
.leftButtonOne span,
.rightButtonOne span {
    width: 0.85rem;
    height: 0.34rem;
    color: #000;
    padding: 0 0.05rem;
    background: linear-gradient(225deg, #9b7c4c 0%, #ffe7c1 100%);
    line-height: 0.34rem;
    border-radius: 0.05rem;
}
.leftButtonOne:hover,
.rightButtonOne:hover {
    transform: translateY(-0.34rem);
    transition: transform 0.5s ease;
}

/* 登录成功后右侧 */
.loginSuccessfulRight {
    display: flex;
}
.balance,
.other {
    margin-right: 0.1rem;
}
.loginSuccessfulRight .name,
.loginSuccessfulRight .amount {
    display: inline-block;
    color: rgba(239, 199, 122);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    vertical-align: top;
}
.loginSuccessfulRight .name {
    max-width: 1rem;
}
.loginSuccessfulRight .amount {
    max-width: 1rem;
}
.balance {
    display: flex;
    align-items: center;
}
.balance i {
    display: inline-block;
    width: 0.15rem;
    height: 0.15rem;
    background: url("../../../../assets/image/myRefresh.png") no-repeat;
    background-size: cover;
    margin-left: 0.05rem;
}

// 余额刷新动画
.refreshAnimation,
.refresReturnAnimation {
    animation: refresh 0.5s infinite linear;
    -moz-animation: refresh 0.5s infinite linear;
    -webkit-animation: refresh 0.5s infinite linear;
    -o-animation: refreshing 0.5s infinite linear;
}
@keyframes refresh {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
@-moz-keyframes refresh {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

@-webkit-keyframes refresh {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
@-o-keyframes refresh {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.loginSuccessfulRight ul {
    display: flex;
    justify-content: center;
    align-items: center;
}
.other li {
    border-right: 0.01rem solid #fff;
    height: 0.15rem;
    line-height: 0.15rem;
    padding: 0 0.05rem;
    box-sizing: border-box;
}
.other li:hover {
    color: rgba(239, 199, 122);
}
.other .logout {
    border: none;
    margin: 0;
}

.loginBorder {
    border-radius: 0.05rem;
    margin: 0.05rem 0.1rem;
    display: flex;
    align-items: center;
}

.codeimg {
    width: 1rem;
    height: 0.3rem;
    background-repeat: no-repeat;
}
.defaultPicture {
    width: 1.8rem;
    height: 0.3rem;
    margin: 0.05rem 0.1rem;
    background-color: #e5e5e5;
    text-align: center;
    color: #b4b4b4;
    line-height: 0.3rem;
    font-size: 0.12rem;
}
/* 极验ui调整 */
.header_container .geetest_holder.geetest_wind {
    height: 0.3rem;
    min-width: 1.8rem;
    .geetest_radar {
        width: 0.2rem;
        height: 0.2rem;
        margin: 0.05rem;
    }
    .geetest_success_btn {
        .geetest_success_box {
            top: 0.02rem;
            left: 0.05rem;
        }
    }
    .geetest_radar_tip.geetest_multi_line {
        line-height: 0.3rem;
    }
    .geetest_radar_tip,
    .geetest_success_radar_tip {
        height: 0.3rem;
        line-height: 0.3rem;
        font-size: 0.12rem;
        padding: 0 0.3rem 0 0.4rem;
    }
}
.lang-s {
    width: 1.2rem;
    input {
        background-color: transparent;
        border: none;
        color: #fff;
    }
}
.lang-p {
    background-color: rgba(0, 0, 0, .8) !important;
    border: 1px solid #505050 !important;
    padding: 0.08rem;
    .popper__arrow {
        display: none !important;
    }
    .el-select-dropdown__item {
        color: #bbb;
    }
    .el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
        background-color: 	rgba(225,179,105, .2);
        color: #fff;
    }
    .selected {
        color: #fff !important;
    }
}
// 极验4 调整
// #gt4{
//     .botion_captcha .botion_holder, .botion_popup_wrap .botion_holder{
//         height: 30px;
//     }
// }
</style>